import { setIn } from 'final-form';

export const validateFormValues = (schema: any) => async (values: any) => {
  if (typeof schema === 'function') {
    schema = schema();
  }
  try {
    await schema.validate(values, { abortEarly: false });
  } catch (err: any) {
    const errors = err.inner.reduce((formError: any, innerError: any) => {
      return setIn(formError, innerError.path, innerError.message);
    }, {});

    return errors;
  }
};

export const required = (value: unknown, fieldName: string) => {
  return value ? undefined : `${fieldName} is required`;
};

export const conditionalCountryRequired = (value: string, fieldName: string, countryId: number) => {
  if (parseInt(countryId.toString()) === 169) {
    return value && value.trim().length ? undefined : `${fieldName} is required`;
  } else {
    return undefined;
  }
};
